import * as _ from 'lodash';

import { selectOptionFactory } from '../../../utils';

const DAY_BY_HALF_HOUR_OPTIONS = [
  selectOptionFactory('00:00:00', '12:00AM'),
  selectOptionFactory('00:30:00', '12:30AM'),
  selectOptionFactory('01:00:00', '1:00AM'),
  selectOptionFactory('01:30:00', '1:30AM'),
  selectOptionFactory('02:00:00', '2:00AM'),
  selectOptionFactory('02:30:00', '2:30AM'),
  selectOptionFactory('03:00:00', '3:00AM'),
  selectOptionFactory('03:30:00', '3:30AM'),
  selectOptionFactory('04:00:00', '4:00AM'),
  selectOptionFactory('04:30:00', '4:30AM'),
  selectOptionFactory('05:00:00', '5:00AM'),
  selectOptionFactory('05:30:00', '5:30AM'),
  selectOptionFactory('06:00:00', '6:00AM'),
  selectOptionFactory('06:30:00', '6:30AM'),
  selectOptionFactory('07:00:00', '7:00AM'),
  selectOptionFactory('07:30:00', '7:30AM'),
  selectOptionFactory('08:00:00', '8:00AM'),
  selectOptionFactory('08:30:00', '8:30AM'),
  selectOptionFactory('09:00:00', '9:00AM'),
  selectOptionFactory('09:30:00', '9:30AM'),
  selectOptionFactory('10:00:00', '10:00AM'),
  selectOptionFactory('10:30:00', '10:30AM'),
  selectOptionFactory('11:00:00', '11:00AM'),
  selectOptionFactory('11:30:00', '11:30AM'),
  selectOptionFactory('12:00:00', '12:00PM'),
  selectOptionFactory('12:30:00', '12:30PM'),
  selectOptionFactory('13:00:00', '1:00PM'),
  selectOptionFactory('13:30:00', '1:30PM'),
  selectOptionFactory('14:00:00', '2:00PM'),
  selectOptionFactory('14:30:00', '2:30PM'),
  selectOptionFactory('15:00:00', '3:00PM'),
  selectOptionFactory('15:30:00', '3:30PM'),
  selectOptionFactory('16:00:00', '4:00PM'),
  selectOptionFactory('16:30:00', '4:30PM'),
  selectOptionFactory('17:00:00', '5:00PM'),
  selectOptionFactory('17:30:00', '5:30PM'),
  selectOptionFactory('18:00:00', '6:00PM'),
  selectOptionFactory('18:30:00', '6:30PM'),
  selectOptionFactory('19:00:00', '7:00PM'),
  selectOptionFactory('19:30:00', '7:30PM'),
  selectOptionFactory('20:00:00', '8:00PM'),
  selectOptionFactory('20:30:00', '8:30PM'),
  selectOptionFactory('21:00:00', '9:00PM'),
  selectOptionFactory('21:30:00', '9:30PM'),
  selectOptionFactory('22:00:00', '10:00PM'),
  selectOptionFactory('22:30:00', '10:30PM'),
  selectOptionFactory('23:00:00', '11:00PM'),
  selectOptionFactory('23:30:00', '11:30PM'),
];

//  Map for looking up the values
export const valuesToOptions = Object.freeze(_.keyBy(DAY_BY_HALF_HOUR_OPTIONS, option => option.value));

export default DAY_BY_HALF_HOUR_OPTIONS;
